<section class="card">
  <div class="mb-10">
    <app-back-button ></app-back-button>
  </div>
  <div class="flex flex-col sm:flex-row sm:items-center gap-6 mb-10">
    <div class="flex-auto">
      <img class="h-20 w-20 object-contain" [src]="store.shopImage" alt="">
    </div>
    <div class="items-end">
      <p-button icon="pi pi-pencil" *ngIf="!isEditing" (click)="toggleEdit()" severity="secondary" rounded />
      <p-button icon="pi pi-check" *ngIf="isEditing" (click)="toggleEdit()" severity="secondary" rounded />
    </div>
  </div>

  <div class="flex flex-col gap-6 w-full sm:w-auto" *ngIf="!isEditing">
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="flex-auto">
        <label class="block font-semibold mb-2 text-lg">Nombre de tienda:</label>
        <span class="text-lg">{{ store.shopName }}</span>
      </div>
      <div class="flex-auto">
        <label class="block font-semibold mb-2 text-lg">Dominio de tienda:</label>
        <span class="text-lg"><a href="https://{{ store.shopDomain }}" target="_blank" rel="noopener noreferrer"><i class="pi pi-spin pi-external-link"></i></a> {{ store.shopDomain }}</span>
      </div>
      <div class="flex-auto">
        <label class="block font-semibold mb-2 text-lg">Plan de tienda:</label>
        <span class="text-lg">{{ store.shopSubscription.shopSubscriptionName }}</span>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="w-2/5">
        <!-- <strong>Apis Publicos ApiKey:</strong> -->
        <label class="block font-semibold mb-2 text-lg">Apis Públicos ApiKey:</label>
        <p-password class="text-lg w-full" *ngIf="store.shopApiKey" [inputStyle]="{'background-color':'transparent','border':'none','box-shadow': 'unset', 'border-radius': '0', 'border-bottom': '1px solid #cbd5e1'}" [(ngModel)]="store.shopApiKey" [feedback]="false" [toggleMask]="true" disabled fluid/>
        <p-password class="text-lg w-full" *ngIf="!store.shopApiKey" [inputStyle]="{'background-color':'transparent','border':'none','box-shadow': 'unset', 'border-radius': '0', 'border-bottom': '1px solid #cbd5e1'}" [(ngModel)]="store.shopApiKey" [feedback]="false" [placeholder]="'No posee'" [toggleMask]="false" disabled fluid/>
        <!-- <span>{{ showApiKey ? store.shopApiKey : '************' }}</span>
        <p-button icon="pi pi-eye" *ngIf="!showApiKey" (click)="toggleApiKeyVisibility()" severity="secondary" rounded pButton />
        <p-button icon="pi pi-eye-slash" *ngIf="showApiKey" (click)="toggleApiKeyVisibility()" severity="secondary" rounded  pButton/> -->
      </div>
      <div class="w-3/5">
        <!-- <strong>infobip apikey:</strong> -->
        <label class="block font-semibold mb-2 text-lg">Infobip ApiKey:</label>
        <p-password class="text-lg w-full" *ngIf="store.infobip_api_key" [inputStyle]="{'background-color':'transparent','border':'none','box-shadow': 'unset', 'border-radius': '0', 'border-bottom': '1px solid #cbd5e1'}" [(ngModel)]="store.infobip_api_key" [feedback]="false" [toggleMask]="true" disabled fluid/>
        <p-password class="text-lg w-full" *ngIf="!store.infobip_api_key" [inputStyle]="{'background-color':'transparent','border':'none','box-shadow': 'unset', 'border-radius': '0', 'border-bottom': '1px solid #cbd5e1'}" [(ngModel)]="store.infobip_api_key" [feedback]="false" [placeholder]="'No posee'" [toggleMask]="false" disabled fluid/>
        <!-- <span>{{ showInfobipApiKey ? store.infobip_api_key : '************' }}</span> -->
        <!-- <p-button icon="pi pi-eye" *ngIf="!showInfobipApiKey" (click)="toggleInfobipApiKeyVisibility()" severity="secondary" rounded pButton />
        <p-button icon="pi pi-eye-slash" *ngIf="showInfobipApiKey" (click)="toggleInfobipApiKeyVisibility()" severity="secondary" rounded  pButton/> -->
      </div>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="flex-auto">
        <!-- <strong>infobip sender phone:</strong> {{ store.infobip_sender }} -->
        <label class="block font-semibold mb-2 text-lg">Infobip Sender Phone:</label>
        <span class="text-lg">{{ store.infobip_sender || 'No posee' }}</span>
      </div>
      <div class="flex-auto">
        <!-- <strong>infobip host uri:</strong> {{ store.infobip_api_host_uri }} -->
        <label class="block font-semibold mb-2 text-lg">Infobip Host URI:</label>
        <span class="text-lg">{{ store.infobip_api_host_uri || 'No posee' }}</span>
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-6 w-full sm:w-auto" *ngIf="isEditing">
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="flex-auto">
        <label for="name" class="block font-semibold mb-2">Nombre de tienda:</label>
        <input id="name" type="text" class="w-full" [(ngModel)]="store.shopName" pInputText/>
      </div>
      <div class="flex-auto">
        <label for="domain" class="block font-semibold mb-2">Dominio de tienda:</label>
        <input id="domain" type="text" class="w-full" [(ngModel)]="store.shopDomain" pInputText />
      </div>
      <div class="flex-auto">
        <label for="plan" class="block font-semibold mb-2">Plan de la tienda:</label>
        <p-select id="plan" class="w-full" [(ngModel)]="store.shopSubscriptionId" [options]="subscriptionsArr" optionLabel="label" 
  optionValue="value"></p-select>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="w-2/4">
        <label for="infobipApiKey" class="block font-semibold mb-2">Infobip Apikey:</label>
        <input id="infobipApiKey" type="text" class="w-full" [(ngModel)]="store.infobip_api_key" pInputText />
      </div>
      <div class="w-1/4">
        <label for="infobipSenderPhone" class="block font-semibold mb-2">infobip sender phone:</label>
        <input id="infobipSenderPhone" type="number" class="w-full" [(ngModel)]="store.infobip_sender" pInputText />
      </div>
      <div class="w-1/4">
        <label for="infobipHostUri" class="block font-semibold mb-2">infobip host uri:</label>
        <input id="infobipHostUri" type="text" class="w-full" [(ngModel)]="store.infobip_api_host_uri" pInputText />
      </div>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-6">
      <div class="w-1/2">
        <label for="apiKey" class="block font-semibold mb-2">Apis Públicos Apikey:</label>
        <input id="apiKey" type="text" class="w-full" [(ngModel)]="store.shopApiKey" pInputText />
      </div>
    </div>
    <div class="flex justify-center">
      <p-button severity="success" [loading]="loading" variant="outlined" rounded (click)="saveStore()">
        Guardar Cambios
      </p-button>
    </div>
  </div>
</section>
<p-toast></p-toast>
<section class="card">
  <app-store-sales></app-store-sales>
</section>